//Desktop
$(document).ready(function () {
    if($('.ce-fp-desktop').length > 0){
        $('body').on('click',function (){
            $('.lvl1_marker').removeClass('touched');
            $('.lvl2_marker').removeClass('touched');
            $('.lvl3_marker').removeClass('touched');
        });
        $('.lvl1_marker,.lvl2_marker,.lvl3_marker').on('click',function (e){
            e.stopPropagation();
        })
        var additionalTextDiv = $('.ce-fp-desktop__additional-text').first();
        additionalTextDiv.data('original',additionalTextDiv.html());
        $('.ce-fp-desktop__back button').on('click',function () {
            var container = $(this).closest('.lvl-container');
            $('.lvl1_marker').removeClass('touched');
            $('.lvl2_marker').removeClass('touched');
            $('.lvl3_marker').removeClass('touched');
            if(container.hasClass('ce-fp-desktop__lvl2')){
                additionalTextDiv.html(additionalTextDiv.data('original'))
                $('.ce-fp-desktop__lvl2__item').hide();
            }
            if(container.hasClass('ce-fp-desktop__lvl1')){
                container.hide();
                additionalTextDiv.hide()
            }

            if(container.hasClass('ce-fp-desktop__lvl3')){
                $('.ce-fp-desktop__lvl3__item').hide();
            }
           //  container.fadeOut(function () {
           //     $('.ce-fp-desktop__lvl2__item').hide();
           // });
        });
        var lvl2_container = $('.ce-fp-desktop__lvl2');
        var lvl3_container = $('.ce-fp-desktop__lvl3');

        $('.ce-fp-desktop__start').on('click',function () {
            $('.ce-fp-desktop__lvl1').fadeIn();
            additionalTextDiv.fadeIn();
        })

        $('.lvl1_marker__animation').on('mousedown',function () {
            var markerTarget = $('.ce-fp-desktop__lvl2 .' + $(this).data('target'));
            if(markerTarget.length > 0){
                markerTarget.fadeIn();
                lvl2_container.fadeIn();
                additionalTextDiv.html(markerTarget.find('.lvl_1_marker__addition').first().html());
            }
        });

        $('.lvl2_marker__animation.sub').on('mousedown',function () {
            var markerTarget = $('.ce-fp-desktop__lvl3 .' + $(this).data('target'));
            if(markerTarget.length > 0){
                markerTarget.fadeIn();
                lvl3_container.fadeIn();
                additionalTextDiv.hide()
            }
        });

        //Tablets touch
        $('.lvl1_marker .l_content_lvl1_marker').on('touchstart click','div.detail',function (){
            var aniContainer = $(this).closest('.lvl1_marker').find('.lvl1_marker__animation').first();
            var markerTarget = $('.ce-fp-desktop__lvl2 .' + aniContainer.data('target'));
            if(markerTarget.length > 0){
                $('.lvl1_marker').removeClass('touched');
                markerTarget.fadeIn();
                lvl2_container.fadeIn();
                additionalTextDiv.html(markerTarget.find('.lvl_1_marker__addition').first().html());
            }
        });

        $('.lvl2_marker.sub .lvl2_marker__content').on('touchstart click','div.detail',function (){
            var aniContainer = $(this).closest('.lvl2_marker').find('.lvl2_marker__animation').first();
            var markerTarget = $('.ce-fp-desktop__lvl3 .' + aniContainer.data('target'));
            if(markerTarget.length > 0){
                $('.lvl2_marker').removeClass('touched');
                markerTarget.fadeIn();
                lvl3_container.fadeIn();
                additionalTextDiv.hide()
            }
        });

        $('.lvl1_marker__animation').on('touchstart',function (e) {
            if($(this).closest('.lvl1_marker').hasClass('touched')){
                $(this).closest('.lvl1_marker').removeClass('touched')
            }else{
                $(this).closest('.lvl1_marker').addClass('touched')
            }
            //avoid to trigger click events on touch device
            return false;
        });

        $('.lvl2_marker__animation').on('touchstart',function () {
            if($(this).closest('.lvl2_marker').hasClass('touched')){
                $(this).closest('.lvl2_marker').removeClass('touched')
            }else{
                $(this).closest('.lvl2_marker').addClass('touched')
            }
            //avoid to trigger click events on touch device
            return false;
        });

        $('.lvl3_marker__animation').on('touchstart',function () {
            if($(this).closest('.lvl3_marker').hasClass('touched')){
                $(this).closest('.lvl3_marker').removeClass('touched')
            }else{
                $(this).closest('.lvl3_marker').addClass('touched')
            }
            //avoid to trigger click events on touch device
            return false;
        });
    }
})

//mobile
$(document).ready(function () {
    if($('.ce-fp-mobile').length > 0 && window.matchMedia('(max-width: 772px)').matches === true){
        $('.ce-fp-mobile .ce-fp-mobile__selector__marker').on('click',function () {
            var target = $(this).data('target');
            var targetDiv = $('.ce-fp-mobile').find('.ce-fp-mobile__component[data-component="' + target + '"]').first();
            $('html, body').animate({
                scrollTop: targetDiv.offset().top
            }, 500, function() {
                // Add hash (#) to URL when done scrolling (default click behavior)
                if (history.pushState) {
                    // IE10, Firefox, Chrome, etc.
                    window.history.pushState(null, null, '#'+target);
                }else{
                    window.location.hash = '#'+target;
                }
            });

        });
        //init sliders
        $('.ce-fp-mobile__component-part-slider').slick({
            infinite: false,
            arrows:false
        })

        $('.ce-fp-mobile__component button.popup').on('click',function (){
            var content = $(this).next().html()
            $('.ce-fp-mobile__popup > .content').html(content);
            $('.ce-fp-mobile__popup').fadeIn();
        });
        $('.ce-fp-mobile__popup button.closer').on('click', function (){
            $(this).closest('.ce-fp-mobile__popup').hide()
        });
    }
});
